module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 028.d232e51f.jpg";